import { useEffect, useState } from 'react';

// Hides the sticky bars while the visitor scrolls down through results and
// brings them back on the first scroll up. On a phone the header plus the
// search/filter bar would otherwise cover a large part of the screen.
const TOP_ZONE = 200; // px from the top where the bars always show
const MIN_DELTA = 6; // smaller movements are jitter, not a direction

export function useHideOnScroll() {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    // Starts from the current position, so a list restored mid-page on Back
    // keeps its bars visible until the visitor actually scrolls.
    let lastY = window.scrollY;
    let frame = null;

    const update = () => {
      frame = null;
      // Clamped so the iOS overscroll bounce never reads as a direction change.
      const maxY = Math.max(document.documentElement.scrollHeight - window.innerHeight, 0);
      const y = Math.min(Math.max(window.scrollY, 0), maxY);

      if (y < TOP_ZONE) {
        setHidden(false);
        lastY = y;
        return;
      }

      const delta = y - lastY;
      if (Math.abs(delta) < MIN_DELTA) {
        return;
      }

      // Never hide the bars from under someone typing in the search box.
      const typing = document.activeElement?.closest?.('.header, .discovery');
      setHidden(delta > 0 && !typing);
      lastY = y;
    };

    const onScroll = () => {
      if (frame === null) {
        frame = requestAnimationFrame(update);
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (frame !== null) {
        cancelAnimationFrame(frame);
      }
    };
  }, []);

  return hidden;
}
